require("./listing.scss");

(function ($) {
    $(function () {
        $(".carousel").carousel();

        $(".badge").tooltip({
            html: true,
            title: function () {
                return $($(this).data("target")).html();
            }
        });

        $(".carousel.lazy").on("slide.bs.carousel",
            function (ev) {
                const lazy = $(ev.relatedTarget).find("img[data-src]");
                lazy.attr("src", lazy.data("src"));
                lazy.removeAttr("data-src");
            });

        $(".js-encode-search").on("click",
            function() {
                const id = $(this).data("webm-networkid");
                const searchContext = window.navigation.searchContext;

                const sort = getUrlParameter("sort");
                const offset = getUrlParameter("offset");
                const limit = getUrlParameter("limit");

                const encoded = encodeURIComponent(`q=${searchContext}&sort=${sort}&offset=${offset}&limit=${limit}`);

                if (window.localStorage) {
                    window.localStorage.setItem(id, encoded);
                }
            });

        function getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            const results = regex.exec(window.location.search.toLowerCase());
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        };
    });
})(jQuery);